import Fetch from 'jsx/common/util/_fetch';

export const remove = async (id: number) => {
  return Fetch.delete(`/api/group/${id}/`);
};
